/* 86b0eac0e4985f276bc76576b85fa26b64be35df
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusTransportationCompanyQueryVariables = Types.Exact<{
  code: Types.Scalars['String'];
}>;


export type BusTransportationCompanyQuery = { __typename?: 'Query', busTransportationCompany?: { __typename?: 'BusTransportationCompany', code: string, address?: string | undefined, abbreviationName: string, name: string, phone?: string | undefined, latitude?: number | undefined, longitude?: number | undefined } | undefined };


export const BusTransportationCompanyDocument = gql`
    query BusTransportationCompany($code: String!) {
  busTransportationCompany(code: $code) {
    code
    address
    abbreviationName
    name
    phone
    latitude
    longitude
  }
}
    `;

/**
 * __useBusTransportationCompanyQuery__
 *
 * To run a query within a React component, call `useBusTransportationCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusTransportationCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusTransportationCompanyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useBusTransportationCompanyQuery(baseOptions: Apollo.QueryHookOptions<BusTransportationCompanyQuery, BusTransportationCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusTransportationCompanyQuery, BusTransportationCompanyQueryVariables>(BusTransportationCompanyDocument, options);
      }
export function useBusTransportationCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusTransportationCompanyQuery, BusTransportationCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusTransportationCompanyQuery, BusTransportationCompanyQueryVariables>(BusTransportationCompanyDocument, options);
        }
export type BusTransportationCompanyQueryHookResult = ReturnType<typeof useBusTransportationCompanyQuery>;
export type BusTransportationCompanyLazyQueryHookResult = ReturnType<typeof useBusTransportationCompanyLazyQuery>;
export type BusTransportationCompanyQueryResult = Apollo.QueryResult<BusTransportationCompanyQuery, BusTransportationCompanyQueryVariables>;